import { I18n } from "laravel-vue-i18n";
export function trans (key, replacements) {
    const i18n = I18n.getSharedInstance();
    if (!i18n.isLoaded(i18n.getActiveLanguage())) {
        return i18n.trans(key, replacements);
    }
    const environment = import.meta.env.VITE_APP_ENV;
    if (environment === 'production') {
        return i18n.trans(key, replacements);
    }
    if (!i18n.activeMessages.hasOwnProperty(key)) {
        if (environment === 'local') {
            console.error('%cMissing Translation: '+key);
        }
    }
    return i18n.trans(key, replacements);
}
